export default __webpack_public_path__ + "static/media/491.5ac3d27d.jpg";